import { render, staticRenderFns } from "./TwProcessGroupListPreviewIpRequestTable.vue?vue&type=template&id=a177d87c&scoped=true&"
import script from "./TwProcessGroupListPreviewIpRequestTable.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListPreviewIpRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListPreviewIpRequestTable.vue?vue&type=style&index=0&id=a177d87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a177d87c",
  null
  
)

export default component.exports